module.exports = __webpack_public_path__ + "assets/c4a502d3e3d5e475c8623cca05df88c4.mp3";